import {
  customScrollMinimal,
  Markdown as MarkdownBase,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

import { DocumentProvider } from '~/modules/document-provider/DocumentProvider';

export const Header = styled.p`
  padding: 12px;
  border-bottom: 1px solid var(--border-default);
  color: var(--text-soft);
  ${typographyV2.bodyXs};
`;

export const Container = styled.div<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border-bottom: 1px solid var(--border-soft);
  cursor: pointer;

  &:hover {
    background: var(--surface-active);
  }

  ${({ $active }) =>
    $active &&
    `
    background: var(--surface-active);
    `}
  max-height: 150px;

  ${DocumentProvider.Styled.StyledLabel} {
    ${typographyV2.bodyXs};
    color: var(--text-soft);
  }
`;

export const MarkdownWrapper = styled.span<{ $condensed?: boolean }>`
  ${customScrollMinimal};
  overflow: auto;
  ${({ $condensed }) => $condensed && `max-height: 100px;`};
  ${typographyV2.bodySm};

  ${MarkdownBase.Styled.MarkdownStyles} {
    p {
      margin-bottom: 0;
    }
  }
`;
